<div class="toolbar">
  <span class="toolbar-label">Market</span>
  <mat-button-toggle-group
    [value]="market()"
    (change)="setMarket($event.value)"
    aria-label="Market"
  >
    @for (iso2 of markets(); track iso2) {
      <mat-button-toggle [value]="iso2">{{ iso2 }}</mat-button-toggle>
    }
  </mat-button-toggle-group>
  <button mat-button type="button" (click)="load()">Refresh counts</button>
</div>

<p class="text-muted intro">
  Active shoppers only (not vendors or admins), in the selected market, who have not unsubscribed.
  Each person gets their own email, sent in the background, up to 1,500 a day; anyone emailed in the
  last 7 days is skipped. Every email has an unsubscribe link. Use
  <code>{{ '{{first_name}}' }}</code> for each person's first name.
</p>
@if (unsubscribed(); as u) {
  <p class="text-muted unsubscribed-count">
    {{ u.market | number }} {{ u.market === 1 ? 'person has' : 'people have' }} unsubscribed in
    {{ market() }} ({{ u.total | number }} in all markets) - they are never sent Email Outreach.
    @if (u.total > 0) {
      <a routerLink="/user_list" [queryParams]="{ outreach: 'unsubscribed' }">See who</a>
    }
  </p>
}

@if (loading()) {
  <div class="spinner"><mat-spinner diameter="32"></mat-spinner></div>
} @else {
  <mat-accordion multi>
    @for (seg of segments(); track seg.key) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>{{ seg.label }}</mat-panel-title>
          <mat-panel-description>
            <span class="count">{{ seg.eligible | number }}</span>
            &nbsp;to email
            @if (seg.skippedRecent) {
              <span class="muted">&nbsp;· {{ seg.skippedRecent | number }} emailed in last 7 days</span>
            }
          </mat-panel-description>
        </mat-expansion-panel-header>

        <dl class="rule">
          <dt>Starting rule</dt>
          <dd>{{ seg.rule }}</dd>
          <dt>Email objective</dt>
          <dd>{{ seg.objective }}</dd>
        </dl>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Subject line</mat-label>
          <input matInput maxlength="200" [(ngModel)]="draft(seg.key).subject" />
        </mat-form-field>

        <angular-editor [(ngModel)]="draft(seg.key).body" [config]="editorConfig"></angular-editor>

        <div class="actions">
          <button
            mat-stroked-button
            type="button"
            [disabled]="!ready(seg.key)"
            (click)="sendTest(seg)"
          >
            {{ busy() === 'test:' + seg.key ? 'Sending test...' : 'Send test to me' }}
          </button>
          <button
            mat-stroked-button
            type="button"
            title="Sends this email to shiqing@fishyhub.com"
            [disabled]="!ready(seg.key)"
            (click)="sendTest(seg, true)"
          >
            {{ busy() === 'inbox:' + seg.key ? 'Sending...' : 'Test Email' }}
          </button>
          <button
            mat-flat-button
            color="primary"
            type="button"
            [disabled]="!ready(seg.key) || seg.eligible === 0"
            (click)="send(seg)"
          >
            {{
              busy() === 'send:' + seg.key
                ? 'Queuing...'
                : 'Send to ' + (seg.eligible | number) + ' user(s)'
            }}
          </button>
        </div>
      </mat-expansion-panel>
    }
  </mat-accordion>

  <h3 class="history-title">Automated emails ({{ market() }})</h3>
  <p class="text-muted intro">
    On by market. While on, each shopper is checked as they come to meet the rule and sent their
    own email straight away - never in a batch - and never twice, even if their cart changes.
    Shares the daily email limit, and skips anyone who has unsubscribed. Use
    <code>{{ '{{first_name}}' }}</code>, <code>{{ '{{cart_total}}' }}</code>,
    <code>{{ '{{delivery_fee}}' }}</code> and <code>{{ '{{cart_link}}' }}</code>.
  </p>
  <mat-accordion multi>
    @for (a of automations(); track a.key) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ a.label }}
            <span class="auto-state" [class.on]="a.enabled">{{ a.enabled ? 'On' : 'Off' }}</span>
          </mat-panel-title>
          <mat-panel-description>
            <span class="count">{{ a.sent | number }}</span>&nbsp;emailed
            <span class="muted">&nbsp;· {{ a.sent24h | number }} in last 24h</span>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <dl class="rule">
          <dt>Rule</dt>
          <dd>{{ a.rule }}</dd>
          <dt>Email objective</dt>
          <dd>{{ a.objective }}</dd>
          <dt>So far ({{ a.iso2 }})</dt>
          <dd>
            {{ a.sent | number }} emailed · {{ a.checked | number }} checked, did not qualify
            @if (a.failed) {
              · <span class="bad">{{ a.failed | number }} failed</span>
            }
            @if (a.updatedBy) {
              <span class="muted"> · last changed by {{ a.updatedBy }}, {{ a.updatedAt | date: 'd MMM y, HH:mm' }}</span>
            }
          </dd>
        </dl>

        <mat-slide-toggle
          color="primary"
          [checked]="a.enabled"
          [disabled]="!!busy()"
          (change)="saveAutomation(a, $event.checked, $event.source)"
        >
          {{ a.enabled ? 'On - sending to shoppers as they qualify' : 'Off' }}
        </mat-slide-toggle>

        <mat-form-field appearance="outline" class="w-100 mt-3">
          <mat-label>Subject line</mat-label>
          <input matInput maxlength="200" [(ngModel)]="autoDraft(a).subject" />
        </mat-form-field>

        <angular-editor [(ngModel)]="autoDraft(a).body" [config]="editorConfig"></angular-editor>

        <div class="actions">
          <button mat-stroked-button type="button" [disabled]="!autoReady(a)" (click)="sendAutoTest(a)">
            {{ busy() === 'test:auto:' + a.key ? 'Sending test...' : 'Send test to me' }}
          </button>
          <button
            mat-stroked-button
            type="button"
            title="Sends this email to shiqing@fishyhub.com"
            [disabled]="!autoReady(a)"
            (click)="sendAutoTest(a, true)"
          >
            {{ busy() === 'inbox:auto:' + a.key ? 'Sending...' : 'Test Email' }}
          </button>
          <button
            mat-flat-button
            color="primary"
            type="button"
            [disabled]="!autoReady(a)"
            (click)="saveAutomation(a, a.enabled)"
          >
            {{ busy() === 'auto:' + a.key ? 'Saving...' : 'Save email' }}
          </button>
        </div>

        @if (a.recent.length) {
          <h4 class="recent-title">Latest</h4>
          <div class="table-wrap">
            <table class="history">
              <thead>
                <tr>
                  <th>When</th>
                  <th>Shopper</th>
                  <th>Cart total</th>
                  <th>Delivery</th>
                  <th>Delivery share</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                @for (r of a.recent; track r.userId) {
                  <tr>
                    <td>{{ (r.sentAt || r.updatedAt) | date: 'd MMM y, HH:mm' }}</td>
                    <td>
                      <a [routerLink]="['/admin/user-details', r.userId]">{{ r.name }}</a>
                      <div class="why">{{ r.email }}</div>
                    </td>
                    <td>{{ r.cartTotal | number: '1.2-2' }}</td>
                    <td>{{ r.deliveryFee | number: '1.2-2' }}</td>
                    <td>{{ ratio(r.deliveryFee, r.cartTotal) }}</td>
                    <td>
                      <span class="status" [class]="r.status">{{ r.status }}</span>
                      @if (r.error) {
                        <div class="why">{{ r.error }}</div>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </mat-expansion-panel>
    }
  </mat-accordion>

  <h3 class="history-title">Recent emails ({{ market() }})</h3>
  @if (!campaigns().length) {
    <p class="text-muted">Nothing sent in this market yet.</p>
  } @else {
    <div class="table-wrap">
      <table class="history">
        <thead>
          <tr>
            <th>Queued</th>
            <th>Segment</th>
            <th>Subject</th>
            <th>Status</th>
            <th>Sent</th>
            <th>Waiting</th>
            <th>Failed</th>
            <th>Not sent</th>
            <th title="People whose last outreach email before unsubscribing was this one">Unsubscribed</th>
            <th>By</th>
          </tr>
        </thead>
        <tbody>
          @for (c of campaigns(); track c.id) {
            <tr>
              <td>{{ c.createdAt | date: 'd MMM y, HH:mm' }}</td>
              <td>{{ labelOf(c.segment) }}</td>
              <td class="subject">{{ c.subject }}</td>
              <td>
                <span class="status" [class]="c.status">{{ c.status }}</span>
              </td>
              <td>{{ c.sent | number }} / {{ c.recipientCount | number }}</td>
              <td>{{ c.pending | number }}</td>
              <td [class.bad]="c.failed > 0">{{ c.failed | number }}</td>
              <td>
                {{ c.skipped | number }}
                @if (notSentReasons(c); as why) {
                  <div class="why">{{ why }}</div>
                }
              </td>
              <td>{{ c.unsubscribed ?? 0 | number }}</td>
              <td>{{ c.createdBy || '-' }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
}
